import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `/${routePrefix}`,
    component: ContainerView,
    meta: { moduleName },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "knowledge" */ './views/list')
          ),
        meta: {},
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "knowledge" */ './views/create')
          ),
        meta: {},
      },
      {
        path: ':id/read',
        name: `${routeNamePrefix}.read`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "knowledge" */ './views/read')
          ),
        meta: {},
      },
      {
        path: ':id/edit',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "knowledge" */ './views/edit')
          ),
        meta: {},
      },
    ],
  },
]
